/*
 *
 *  * Copyright (c) 2021.
 *  * Md Naimul Hasan
 *  * naim886@gmail.com
 *  * 01719123886
 *  * www.naimbd.com
 *
 */

import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {toast, ToastContainer} from "react-toastify";
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Constants";

const PaypalSettings = () => {
    const [input, setInput] = useState({});
    const [errMsg, setErrMsg] = useState({});
    const [isLoading, setIsLoading] = useState(false)
    const handleInput = (e) => {
        setInput(prevState => ({...prevState, [e.target.name] : e.target.value}))
    }
    const savePaypal = () => {
        setIsLoading(true)
       axios.post(BASEURL+'/api/provider/paypal', input).then(res=>{
           setErrMsg({})
           toast.success(res.data.msg)
           setIsLoading(false)
       }).catch(function (errors){
           setErrMsg({})
            if (errors.response.status == 422){
                setErrMsg(errors.response.data.errors)
            }
           setIsLoading(false)
       })
    }
    const getPaypalData = () => {
        axios.get(BASEURL+'/api/provider/paypal').then(res=>{
            setInput({company_name:res.data.company_name, email: res.data.email, client_id: res.data.client_id})
        })
    }
    useEffect(() => {
        getPaypalData()
    }, []);

    return (
        <main>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Helmet>
                <title>Paypal Settings | Dashboard - Mega Trash Removal</title>
            </Helmet>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Paypal Settings</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Paypal Settings</li>
                </ol>
                <div className="my-card">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="alert alert-danger" role="alert">
                              <small><i className="fas fa-exclamation-triangle"/> All Information are confidential, sensitive and related to financial activity! Please be careful to change any information <i className="fas fa-exclamation"/></small>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h4>Inset Your PayPal Details</h4>
                                </div>
                                <div className="card-body">
                                    <label>
                                        Company Name
                                        <input
                                            type={'text'}
                                            onChange={handleInput}
                                            value={input.company_name}
                                            name={'company_name'}
                                            className={'form-control'}
                                            placeholder={'Inset Your Company Name'}/>

                                        {Object.entries(errMsg).map(([key, val]) => (
                                            <small
                                                className="text-danger validation-error-message"
                                                key={key}>{key == 'company_name' ? val : ''}
                                            </small>
                                        ))}
                                    </label>
                                    <label className={'mt-4'}>
                                        PayPal Email
                                        <input
                                            type={'email'}
                                            onChange={handleInput}
                                            value={input.email}
                                            name={'email'}
                                            className={'form-control'}
                                            placeholder={'Inset Your PayPal Business Account Email'}/>

                                        {Object.entries(errMsg).map(([key, val]) => (
                                            <small
                                                className="text-danger validation-error-message"
                                                key={key}>{key == 'email' ? val : ''}
                                            </small>
                                        ))}
                                    </label>
                                    <label className={'mt-4'}>
                                        PayPal ClientID
                                        <input
                                            type={'text'}
                                            onChange={handleInput}
                                            value={input.client_id}
                                            name={'client_id'}
                                            className={'form-control'}
                                            placeholder={'Inset Your PayPal Business Account ID'}/>

                                        {Object.entries(errMsg).map(([key, val]) => (
                                            <small
                                                className="text-danger validation-error-message"
                                                key={key}>{key == 'client_id' ? val : ''}
                                            </small>
                                        ))}
                                    </label>
                                    <div className="d-grid mt-4">
                                        <button onClick={savePaypal} className={'btn btn-success'} dangerouslySetInnerHTML={{__html: isLoading?'<span class="spinner-border spinner-border-sm"/>':'Save'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PaypalSettings;
